/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react/require-default-props */
import * as time from '@helpers/time';
import EmpreintesCarboneAPIService from '@services/api/EmpreintesCarboneAPIService';
import { EmpreintesCarboneData } from '@services/interfaces/generated/YSER-v1';
import { AxiosError } from 'axios';
import React from 'react';
import { UseQueryResult } from 'react-query';
import { useOAuth } from '../auth-provider';
import { useBQuery } from '../bquery-provider';
import { useOverrideQuery } from '../helpers';
import { useSiren } from '../siren-context';

const EmpreintesCarboneAPIContext = React.createContext<EmpreintesCarboneAPIService | null>(null);
const EmpreintesCarboneCacheKey = 'EmpreintesCarbone';
export type EmpreintesCarboneAPIProviderProps = {
  mockInstance?: EmpreintesCarboneAPIService;
};

export const EmpreintesCarboneAPIProvider: React.FC<EmpreintesCarboneAPIProviderProps> = ({
  children,
  mockInstance = undefined,
}) => {
  const BQuery = useBQuery();

  const instance = React.useMemo(() => {
    if (!!mockInstance) return mockInstance;

    return new EmpreintesCarboneAPIService(BQuery);
  }, [mockInstance, BQuery]);

  return <EmpreintesCarboneAPIContext.Provider value={instance}>{children}</EmpreintesCarboneAPIContext.Provider>;
};

/**
 * Hook pour accéder au service API Empreintes Carbone
 */
export const useEmpreintesCarboneAPI = (): EmpreintesCarboneAPIService => {
  const context = React.useContext(EmpreintesCarboneAPIContext);
  if (context === undefined || context === null) {
    throw new Error('The `useEmpreintesCarboneAPI` hook must be used within a EmpreintesCarboneAPIProvider');
  }
  return context;
};

export const useObtenirEmpreintesCarboneEquipements = (
  href?: string,
): UseQueryResult<EmpreintesCarboneData | undefined, AxiosError> => {
  const empreintesCarboneAPI = useEmpreintesCarboneAPI();
  const auth = useOAuth();
  const siren = useSiren();

  return useOverrideQuery(
    [EmpreintesCarboneCacheKey, href, siren?.raisonSociale],
    () =>
      empreintesCarboneAPI.obtenirEmpreintesCarboneEquipements(href, {
        idToken: auth.idToken,
        raisonSociale: siren?.raisonSociale,
      }),
    {
      cacheTime: time.fromMinutes(5), // Cache pendant 5 minutes
      staleTime: time.fromMinutes(2), // Considéré comme obsolète après 2 minutes
    },
  );
};
